require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

require("core-js/modules/web.dom-collections.for-each");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.barcodeBindRecord = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var _default = {
    name: 'XiazengBarcodeBindRecord',
    data: function data() {
      return {
        mode: 'batch',
        totalCount: 0,
        // 按提交
        submitList: [],
        submitPageNo: 1,
        submitTotal: 0,
        isShowAll: false,
        loaded: false,
        // 按批次
        batchList: [],
        batchLoaded: false
      };
    },
    created: function created() {
      this.loadBatchData();
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      switchMode: function switchMode(mode) {
        if (this.mode === mode) return;
        this.mode = mode;

        if (mode === 'batch' && !this.batchLoaded) {
          this.loadBatchData();
        }
      },
      // 按提交 - 分页加载
      loadSubmitData: function loadSubmitData() {
        var vm = this;
        vm.$http({
          method: 'GET',
          url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/bindRecord',
          params: {
            pageSize: 20,
            pageNo: vm.submitPageNo
          }
        }).then(function (res) {
          var data = res.data || {};
          vm.totalCount = data.boundCount || 0;
          var records = data.records && data.records.records || [];
          records.forEach(function (item) {
            var timeStr = item.barcodeBindAt || '';
            item.date = timeStr.split(' ')[0] || '-';
            item.time = timeStr.split(' ')[1] || '';
            item.userName = item.operationName || '-';
            item.count = 1;
          });
          vm.submitList = vm.submitPageNo === 1 ? records : vm.submitList.concat(records);
          vm.submitTotal = data.records && data.records.total || 0;
          vm.isShowAll = vm.submitList.length >= vm.submitTotal;
          vm.loaded = true;
        }).catch(function () {
          vm.loaded = true;
        });
      },
      // 按批次 - 一次性加载
      loadBatchData: function loadBatchData() {
        var vm = this;
        vm.$http({
          method: 'GET',
          url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/bindRecord/byBatch'
        }).then(function (res) {
          var data = res.data || {};
          vm.totalCount = data.totalBoundCount || 0;
          vm.batchList = data.batches || [];
          vm.batchLoaded = true;
        }).catch(function () {
          vm.batchLoaded = true;
        });
      },
      // 滚动加载更多（仅按提交模式）
      handleScroll: function handleScroll() {
        var vm = this;
        if (vm.mode !== 'submit' || vm.isShowAll) return;
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var scrollHeight = document.documentElement.scrollHeight;
        var clientHeight = document.documentElement.clientHeight;

        if (scrollTop + clientHeight >= scrollHeight - 50) {
          vm.submitPageNo++;
          vm.loadSubmitData();
        }
      }
    }
  };
  _exports.default = _default;
});